import { Api } from "../api/Api";
import * as EnvConstants from "../Constants/EnvConstants";
import { useErrorWebhook } from "./useErrorWebhook";

export const useLogRecord = () => {
  const { ErrorWebhookTrigger } = useErrorWebhook();
  const updateLogRecord = async (
    uuid,
    api_name,
    timeTakenApi,
    startDateTime,
    endDateTime
  ) => {
    const response = await Api.post("api/v1/api-time-taken-log", {
        uuid,
        api_name,
        timeTakenApi,
        startDateTime,
        endDateTime
    }).catch(function (error) {
      const erroMessage = {
        serviceName: 'API TIME TAKEN LOG',
        errorReason: error.message,
        errorCode: error.code,
        uuid: uuid
      };
      ErrorWebhookTrigger(erroMessage);
    });
    return response;
  };
  return { updateLogRecord };
};
